<template lang="pug">
    .settings(v-if='settings')
        template
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
                | {{ settings.difficult.amountOfRows + ' x ' + settings.difficult.amountOfColumns }}
            br
            template
                | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}:
                template(v-if='settings.selectedItems.value')
                    span
                        | {{ ' ' +  $i18n.t('trainer.trainer_gameFormSetting_' + settings.selectedItems.value)}}
                    br
        br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
    };
</script>
